export default {
      id: "ic_chance_games_refresh-usage",
      viewBox: "0 0 17 13",
      url: "/" + "images/icons.3.109.2.svg#ic_chance_games_refresh-usage",
      toString: function () {
        return this.url;
      }
    }